var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5855 8.95069C22.6972 8.36498 22.2505 7.66214 21.6921 7.66214L15.3265 6.72501L12.4228 0.633679C12.3112 0.399397 12.1995 0.282256 11.9761 0.165115C11.4178 -0.186308 10.7477 0.047974 10.4127 0.633679L7.62072 6.72501L1.2551 7.66214C0.920065 7.66214 0.69671 7.77928 0.585033 8.01356C0.138323 8.48212 0.138323 9.18497 0.585033 9.65353L5.16381 14.3392L4.04704 21.0162C4.04704 21.2505 4.04704 21.4848 4.15871 21.7191C4.49375 22.3048 5.16381 22.539 5.7222 22.1876L11.4178 19.0248L17.1133 22.1876C17.225 22.3048 17.4483 22.3048 17.6717 22.3048H17.895C18.4534 22.1876 18.9001 21.6019 18.7885 20.8991L17.6717 14.222L22.2505 9.53639C22.4738 9.41925 22.5855 9.18497 22.5855 8.95069Z",
    fill: "#FFFFFF "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/Clients.269779392c4ba1112d422880957d1571.svg";
export { ForwardRef as ReactComponent };